import { DecisionDrawer, type DecisionDrawerProps } from './OfficeDecisionDrawer.js';

/**
 * Gemide erteleme kararı (plan M7 Task 14a; K10): kaptan başmühendisin erteleme talebini onaylar
 * ya da gerekçeyle iade eder; onay gemide biter, ofis görür ve gerekirse müdahale eder (ADR 0108)
 * [NR496 4.5.3d].
 */
export function PostponementDecisionDrawer(props: Omit<DecisionDrawerProps, 'at'>) {
  return <DecisionDrawer {...props} at="ship" />;
}
